var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g({staticClass:"white--text p-4 label-chip mb-0",class:[
    _vm.small ? 'label-chip--small' : '',
    _vm.xsmall ? 'label-chip--xsmall' : '',
    _vm.removable ? 'pr-0' : '',
  ],attrs:{"color":_vm.item.color || _vm.item.colorScheme}},_vm.clickable ? { click: _vm.filterClick } : {}),[_vm._v(" "+_vm._s(_vm.item.title)+" "),(_vm.removable)?_c('v-btn',{staticClass:"ml-1",attrs:{"icon":"","x-small":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('unassign-label', _vm.item)}}},[_c('v-icon',{staticClass:"white--text",attrs:{"size":"12"}},[_vm._v(" $close ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }